import axios from "../../config/axiosConfig";
import { CREATE_VEHICLE, GET_VEHICLE, VEHICLE_REQUEST, DELETE_VEHICLE, UPDATE_VEHICLE, VEHICLE_REQUEST_FAILURE } from "../types";
import { addMasterInOption, updateMasterInOption } from "./master-options-actions";

export const getVehicles = () => {
  return async (dispatch, getState) => {
    try {
      dispatch({ type: VEHICLE_REQUEST });
      const { auth } = getState();
      let params = { customerId: auth?.user?.Customer_Id };
      if (!auth?.company?.Common_Master) {
        params = { ...params, companyId: auth.company?.id }
      }
      return axios.get("/vehicle/getAll", { params }).then((response) => {
        if (response.data) {
          dispatch({ type: GET_VEHICLE, payload: response.data });
        }
        return response;
      }).catch((error) => {
        console.error(error);
        dispatch({ type: VEHICLE_REQUEST_FAILURE, error: error.message });
      });
    } catch (error) {
      console.error(error);
      dispatch({ type: VEHICLE_REQUEST_FAILURE, error: error.message });
      throw error;
    }
  };
};

export const createVehicle = (vehicle) => {
  return async (dispatch, getState) => {
    try {
      const { auth } = getState();
      dispatch({ type: VEHICLE_REQUEST });
      return axios.post("/vehicle/add", vehicle,
        { params: { userId: auth.user?.id, companyId: auth.company?.id, customerId: auth?.user?.Customer_Id }}
      ).then((response) => {
        if (response.data) {
          dispatch({ type: CREATE_VEHICLE, payload: response.data });
          dispatch(addMasterInOption('vehicles', response.data));
        } else {
          dispatch({
            type: VEHICLE_REQUEST_FAILURE,
            error: "Vehicle create failed.",
          });
        }
        return response;
      }).catch((error) => {
        console.error(error);
        dispatch({ type: VEHICLE_REQUEST_FAILURE, error: error.message });
        throw error;
      });
    } catch (error) {
      console.error(error);
      dispatch({ type: VEHICLE_REQUEST_FAILURE, error: error.message });
      throw error;
    }
  };
};

export const updateVehicle = (id, data) => {
  return async (dispatch, getState) => {
    try {
      dispatch({ type: VEHICLE_REQUEST });
      const { auth } = getState();
      return axios.put("/vehicle/update", { id, data }, { params: { userId: auth.user?.id }}).then((response) => {
        if (response.data) {
          dispatch({
            type: UPDATE_VEHICLE,
            payload: { id, data: response.data },
          });
          dispatch(updateMasterInOption('vehicles', id, response.data));
        } else {
          dispatch({
            type: VEHICLE_REQUEST_FAILURE,
            error: "Vehicle update failed.",
          });
        }
        return response;
      }).catch((error) => {
        console.error(error);
        dispatch({ type: VEHICLE_REQUEST_FAILURE, error: error.message });
        throw error;
      });
    } catch (error) {
      console.error(error);
      dispatch({ type: VEHICLE_REQUEST_FAILURE, error: error.message });
      throw error;
    }
  };
};

export const deleteVehicle = (id) => {
  return async (dispatch) => {
    try {
      dispatch({ type: VEHICLE_REQUEST });
      return axios.delete(`/vehicle/delete/${id}`).then((response) => {
        if (response.data) {
          dispatch({ type: DELETE_VEHICLE, id: id });
          dispatch(updateMasterInOption('vehicles', id));
        }
        return response;
      }).catch((error) => {
        console.error(error);
        dispatch({ type: VEHICLE_REQUEST_FAILURE, error: error.message });
        throw error;
      });
    } catch (error) {
      console.error(error);
      dispatch({ type: VEHICLE_REQUEST_FAILURE, error: error.message });
      throw error;
    }
  };
};
